module.exports = __webpack_public_path__ + "static/media/semiboquilla-02.c676642e.jpg";